export default __webpack_public_path__ + "static/media/wallet-icon.411b20f4.svg";